import { useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'src/services';
import { useAppDispatch } from 'src/services/redux/app/Store';
import { setDraftTemplateReducer } from 'src/services/redux/slices/template/template-slice';
import { KTSVG, toAbsoluteUrl } from '../../../../_metronic/helpers';
import { useCreateWidget } from '../../services';
import ProductCard from '../ProductCard';

type VendorProductListType = {
  mobileDevice: boolean;
  productList: any;
  templateId: number;
};

export default function VendorProductList(props: VendorProductListType) {
  const { mobileDevice, productList, templateId } = props;
  const [activeWidgetData, setActiveWidgetData] = useState<any>([]);
  const [editWidget, setEditWidget] = useState(false);
  const merhcantTemplateId = useSelector<RootState, number>((state) => state.template.merchantTemplateId);
  const dispatch = useAppDispatch();
  const { mutateAsync: createWidget } = useCreateWidget();
  if (!productList?.status) return null;

  const handleChange = async (productListAlgorithm: string) => {
    const activeWidget = merhcantTemplateId > 0 ? String(merhcantTemplateId) : '';
    const payload = {
      productListType: 'AUTOMATIC',
      productListAlgorithm,
      template: templateId,
      templateItem: productList?.id,
    };
    const response: any = await createWidget({ payload, schema: activeWidget });
    setActiveWidgetData(response.widgetData.widgets);
    dispatch(setDraftTemplateReducer(true));
    setEditWidget(false);
  };

  return (
    <div className="d-flex px-6 flex-column gap-2">
      <div className={`fw-bold d-flex gap-4 align-items-center ${mobileDevice ? 'fs-4' : 'fs-2'}`}>
        {activeWidgetData.length > 0 && !editWidget ? (
          <div className="d-flex align-items-center justify-content-between w-100">
            <div className="d-flex align-items-center gap-4">
              <span>{activeWidgetData.find((title: any) => title.placeholder === productList.position.placeholder).title} </span>
              <div className="d-flex gap-2 align-items-center cursor-pointer" onClick={() => setEditWidget(true)}>
                <KTSVG path="/media/icons/duotone/Design/Edit.svg" className="svg-icon-1 svg-icon-primary" />
                <span className="fs-9 text-muted">Düzenle</span>
              </div>
            </div>
            <div className="fs-8 text-danger">Bu alan nasıl görüneceğinin ön izlemesidir.</div>
          </div>
        ) : productList?.widgets?.[0]?.title && !editWidget ? (
          <div className="d-flex align-items-center justify-content-between w-100">
            <div className="d-flex align-items-center gap-4">
              <span>{productList?.widgets?.[0]?.title} </span>
              <div className="d-flex gap-2 align-items-center cursor-pointer" onClick={() => setEditWidget(true)}>
                <KTSVG path="/media/icons/duotone/Design/Edit.svg" className="svg-icon-1 svg-icon-primary" />
                <span className="fs-9 text-muted">Düzenle</span>
              </div>
            </div>
            <div className="fs-8 text-danger">Bu alan nasıl görüneceğinin ön izlemesidir.</div>
          </div>
        ) : (
          <>
            <div className="d-flex align-items-center justify-content-between w-100">
              <div className="d-flex gap-2 align-items-center">
                <div className="d-flex">Ürün Listesi:</div>
                <div className="d-flex">
                  <select className="form-select" aria-label="Select example" onChange={(e: any) => handleChange(e.target.value)}>
                    <option>Seçiniz</option>
                    {productList?.ruleSet?.useable_list?.map((list: any, index: number) => (
                      <option key={index} value={list.algorithm}>
                        {list.title}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="fs-8 text-danger">Bu alan nasıl görüneceğinin ön izlemesidir.</div>
            </div>
          </>
        )}
      </div>
      <div className="d-flex w-100 align-items-center justify-content-center">
        {activeWidgetData.length > 0 && !editWidget ? (
          <ProductCard mobileDevice={mobileDevice} />
        ) : productList?.widgets?.[0]?.title && !editWidget ? (
          <ProductCard mobileDevice={mobileDevice} />
        ) : (
          <img src={toAbsoluteUrl(`/media/showcasepage-images/${mobileDevice ? 'ide-productlist-mobile' : 'ide-productlist'}.png`)} alt="Idefix Coupons" />
        )}
      </div>
    </div>
  );
}
